export default {
  sanity: {
    projectId: "oehoh5py",
    dataset: "production",
    useCdn: true,
  },
};
